import PropTypes from 'prop-types';
import React from 'react';

function ClockIcon({title}) {
  return (
    <svg className="clock-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <g fillRule="evenodd">
        <path d="M32 57.6C17.92 57.6 6.4 46.08 6.4 32 6.4 17.92 17.92 6.4 32 6.4c14.08 0 25.6 11.52 25.6 25.6 0 14.08-11.52 25.6-25.6 25.6M32 0C14.24 0 0 14.4 0 32s14.24 32 32 32c17.76 0 32-14.4 32-32S49.6 0 32 0"/>
        <path d="M33.6 16h-4.8v19.2l16.8 10.08 2.4-4-14.4-8.48"/>
      </g>
    </svg>
  );
}

ClockIcon.propTypes = {
  title: PropTypes.string.isRequired
}

export default ClockIcon



// WEBPACK FOOTER //
// ./modules/Common/components/svg/ClockIcon.js